<template>
    <div v-if="isVisible" class="guide_box1 guide_position">
      <div class="guide_text1">{{ message }}</div>
      <div class="deep1"></div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      isVisible: {
        type: Boolean,
        required: true,
      },
      message: {
        type: String,
        default: ' ', // 默认提示信息
      },
    },
  };
  </script>
  
  <style scoped lang="less">

  </style>
  